/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Use_External_StickersInputs */



/**
* | output |
* | --- |
* | "Use External Stickers" |
*
* @param {Leveling_Perm_Use_External_StickersInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_use_external_stickers = /** @type {((inputs?: Leveling_Perm_Use_External_StickersInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Use_External_StickersInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Использовать внешние стикеры")
	return /** @type {LocalizedString} */ ("Use External Stickers")
});